export default function Hero() {
  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20editorial%20magazine%20collage%20background%20in%20warm%20coral%2C%20orange%20and%20cream%20tones%2C%20large%20glossy%20question%20mark%20and%20exclamation%20mark%20symbols%20floating%2C%20playful%20speech%20bubble%20shapes%2C%20camera%20flash%20glare%2C%20film%20frames%20and%20scattered%20confetti%2C%20bold%20abstract%20modern%20art%2C%20soft%20warm%20depth%2C%20no%20text&width=1600&height=900&seq=chigua-hero-bg-01&orientation=landscape"
          alt="吃瓜反差神转折与意外结局的背景装饰插画"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/55"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30"></div>
      </div>

      <div className="relative mx-auto flex w-full min-h-[560px] max-w-7xl flex-col justify-center px-4 py-28 md:min-h-[680px] md:px-6 md:py-36">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-accent-300/60 bg-accent-500/15 px-3.5 py-1.5 text-xs font-semibold tracking-wide text-accent-100 md:text-sm">
            <i className="ri-fire-fill text-accent-400" aria-hidden="true"></i>
            全网吃瓜反差 · 神转折集中地
          </p>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            反转，往往藏在
            <span className="text-accent-400">最后一句话</span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-lg">
            这里是神转折、结局意外与剧情神展开的吃瓜基地。每篇瓜先讲开头，结局先替你憋着——
            直到你猜完再「揭晓」，让意想不到的结尾与意外收场一次反转到底。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#library"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:text-base"
            >
              去看反转现场
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-100/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 md:text-base"
            >
              <i className="ri-flashlight-line" aria-hidden="true"></i>
              先刷神转折头条
            </a>
          </div>
        </div>

        <div className="mt-14 grid w-full grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
          {[
            { num: "2800+", label: "整理收录的反转瓜", icon: "ri-stack-line" },
            { num: "8 大类", label: "吃瓜主题分类", icon: "ri-price-tag-3-line" },
            { num: "96%", label: "结局出乎意料的比例", icon: "ri-eye-off-line" },
            { num: "每天", label: "更新新鲜神转折", icon: "ri-refresh-line" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-100/15 bg-background-50/10 p-4 text-center backdrop-blur-sm"
            >
              <i className={`${s.icon} text-xl text-accent-400`} aria-hidden="true"></i>
              <p className="mt-2 font-heading text-xl font-black text-background-50 md:text-2xl">{s.num}</p>
              <p className="mt-1 text-xs text-background-100/80 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}